import { z } from 'zod';
export const DocumentExtensionSchema = z.enum(['pdf']);
export const DocumentTypeSchema = z.enum(['photoReport', 'draftDocument', 'nothing']);
export const DocumentTypeEnum = DocumentTypeSchema.enum;
